<template>
  <div class="wrapper" :class="{ overlay: overlay }">
    <div v-if="scrollOnMobile" class="scroll-indicator">
      <div class="instructions">
        Scroll left and right
        <br />to see more
      </div>

      <div class="animation scroll">
        <Icon class="left-icon" large color="primary" name="chevronLeft" />
        <img class="touch-icon" src="/images/icons/icon-touch.svg" />
        <Icon class="right-icon" large color="primary" name="chevronRight" />
      </div>

      <a class="action" @click="hideAnimation()">
        <Icon large color="primary" name="tick" />
      </a>
    </div>

    <div v-if="rotateOnMobile" class="rotate-indicator">
      <div class="instructions">
        Rotate to landscape
        <br />to see more
      </div>

      <div class="animation rotate">
        <img class="phone-icon" src="/images/icons/icon-phone.svg" />
      </div>

      <a class="action" @click="hideAnimation()">
        <Icon large color="secondary" name="cross" />
      </a>
    </div>

    <div class="image-wrapper">
      <div
        class="image"
        :class="{ fit: fitToWidth }"
        :style="{ backgroundImage: `url(${image})` }"
      />
    </div>
  </div>
</template>

<script>
import Icon from "./../icons";

export default {
  name: "HeroImage",
  components: {
    Icon
  },
  props: {
    image: String,
    alt: String,
    overlay: Boolean,
    fitToWidth: Boolean,
    rotateOnMobile: Boolean,
    scrollOnMobile: Boolean
  },
  methods: {
    hideAnimation() {
      this.rotateOnMobile = false;
      this.scrollOnMobile = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  position: relative;
  max-width: 100vw;

  &.overlay {
    position: absolute;
    left: 0;
    top: 0;
  }

  .image-wrapper {
    display: flex;
    position: relative;
    width: 100vw;
    max-height: 80vh;
    height: 1000px;
    overflow-x: scroll;
    cursor: grab;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 64px;
    margin-top: 32px;
    background: rgba(0, 0, 0, 0.1);

    @media (max-width: 900px) and (orientation: landscape) {
      max-height: 110vh;
    }

    .image {
      /* background: rgba(0, 0, 0, 0.1); */
      /* height: 100vh;
      max-height: 100vh;
      min-height: 400px; */
      display: block;
      height: 100%;
      width: 100vw;
      background-size: cover;
      background-position: center;

      &.fit {
        @media (min-width: 900px), (orientation: landscape) {
          /* max-width: 100vw; */
        }
      }
    }
  }

  .rotate-indicator {
    @media (max-width: 900px) and (orientation: portrait) {
      display: flex !important;

      @media (max-width: 900px) and (orientation: landscape) {
        display: none !important;
      }
    }
  }

  .scroll-indicator {
    @media (max-width: 900px) {
      display: flex !important;

      @media (max-width: 900px) and (orientation: landscape) {
        display: none !important;
      }
    }
  }

  .rotate-indicator,
  .scroll-indicator {
    display: none;
    position: absolute;
    flex-direction: column;
    left: calc(50% - 128px);
    top: calc(50% - 160px);
    z-index: 1;
    border-radius: 16px;
    background: rgba(45, 45, 45, 0.8);
    backdrop-filter: blur(4px);

    .animation {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 256px;
      height: 96px;
      margin: 8px 0 16px;
      padding: 0 24px;
      box-sizing: border-box;

      &.rotate {
        justify-content: center;
      }

      &.scroll {
        justify-content: space-between;
      }
    }

    .instructions {
      font-family: "Public Sans", serif;
      width: 240px;
      line-height: 24px;
      font-size: 16px;
      color: #ffffff;
      padding: 32px 8px 0;
      letter-spacing: 0.02em;
    }

    .action {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 48px;
      height: 48px;
      transition: 0.2s all ease-out;
      cursor: pointer;
      font-family: "Montserrat", sans-serif;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      color: #ffffff;
      line-height: 48px;
      font-size: 20px;
      margin: 0 0 32px;
      border-radius: 30px;
      border: 2px solid #ffffff;
      align-self: center;
      box-sizing: border-box;

      &:hover,
      &:active,
      &:focus {
        transform: scale(1.1);
      }
    }

    @keyframes rotate {
      20% {
        transform: rotate(0);
      }
      45% {
        transform: rotate(-90deg);
      }
      55% {
        transform: rotate(-90deg);
      }
      80% {
        transform: rotate(0);
      }
    }

    @keyframes pan-left {
      0% {
        opacity: 0;
      }
      30% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      60% {
        opacity: 1;
      }
      80% {
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }

    @keyframes pan-hand {
      0% {
        transform: translateX(0);
      }
      20% {
        transform: translateX(32px);
      }
      60% {
        transform: translateX(-32px);
      }
      80% {
        transform: translateX(0);
      }
    }

    @keyframes pan-right {
      0% {
        opacity: 0;
      }
      20% {
        opacity: 1;
      }
      40% {
        opacity: 0;
      }
      100% {
        opacity: 0;
      }
    }

    .touch-icon {
      animation: pan-hand 3s infinite;
      margin-right: -4px;
      margin-left: 4px;
    }

    .phone-icon {
      animation: rotate 3s infinite;
    }

    .left-icon {
      animation: pan-left 3s infinite;
    }

    .right-icon {
      animation: pan-right 3s infinite;
    }
  }
}
</style>
